const BatabotActionTypes = {
  GET_ACCESS: "GET_ACCESS",
};

export default BatabotActionTypes;
